<template>
    <div class="elle-search-form">
        <div class="field-box">
            <div class="input">
                <input type="text" name="search" :placeholder="$t('forms.search.placeholder_search')" @input="e => onChnageQueryString(e)" />
            </div>
            <div class="icon">
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 11.9016L1 15.9016" stroke="black" />
                    <circle cx="9.69531" cy="7.09836" r="6.5" stroke="black" />
                </svg>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const emit = defineEmits(['changeQuery']);
const onChnageQueryString = (e: Event) => {
    const target = e.target as HTMLInputElement | null;
    nextTick(() => emit('changeQuery', target?.value ?? ''));
};
</script>
